(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ocean-wholesale-packages"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
 const link=event.target.closest('[data-owb-request]');
 if(!link) return;
 const source=link.closest('.owb-purchase');
 const option=source.querySelector('[data-owb-size]').selectedOptions[0];
 const target=document.getElementById('ocean-wholesale-request');
 if(!target || !option) return;
 const product=target.querySelector('[name="contact[Product]"]');
 const quantity=target.querySelector('[name="contact[Estimated quantity]"]');
 const notes=target.querySelector('[name="contact[body]"]');
 if(product){product.value='Stone Crab Claws';product.dispatchEvent(new Event('change',{bubbles:true}));}
 if(quantity){quantity.value=source.dataset.weight+' lb · '+option.dataset.size;quantity.dispatchEvent(new Event('input',{bubbles:true}));}
 if(notes){
 const line='Wholesale Stone Crab: '+source.dataset.weight+' lb · '+option.dataset.size+' · '+option.dataset.price;
 const previous=notes.dataset.owbLine;
 let body=notes.value;
 if(previous) body=body.replace(previous,'').trim();
 notes.value=body?body+'\n'+line:line;
 notes.dataset.owbLine=line;
 notes.dispatchEvent(new Event('input',{bubbles:true}));
 }
 event.preventDefault();
 target.scrollIntoView({behavior:'smooth',block:'start'});
 const focus=target.querySelector('[name="contact[Company]"]');
 if(focus) focus.focus({preventScroll:true});
});

  } catch(e) { console.error(e); }
})();
})();
